import { ApiResponse } from 'apisauce';

const readBlobText = (blob: Blob) =>
  new Promise<string>((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : '');
    reader.onerror = () => resolve('');
    reader.readAsText(blob);
  });

/**
 * The message to show for a failed file download, or null when it succeeded.
 *
 * With responseType 'blob' an error body arrives as a Blob too; saving it as the file gave users an
 * .xlsx Excel refuses to open ("file format or file extension is not valid").
 */
export async function downloadErrorMessage(
  res: ApiResponse<any>,
  fallback: string
): Promise<string | null> {
  if (res.ok) return null;

  const text = res.data instanceof Blob ? (await readBlobText(res.data)).trim() : '';

  // Plain-text messages come from the API; an HTML page is a gateway or proxy error.
  return text && !text.startsWith('<') ? text : fallback;
}
